export const LOADING = 'request/LOADING'
export const RESET = 'request/RESET'
